export default {
  "content": "<rect width=\"48\" height=\"48\" rx=\"24\" fill=\"#4141A2\"/><g clip-path=\"url(#clip0_4965_1185)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M29.278 23.157a5 5 0 11-5.556-8.314 5 5 0 015.556 8.314zm-9.445-2.074a2.083 2.083 0 11-4.166 0 2.083 2.083 0 014.166 0zm-2.5 9.167a5.425 5.425 0 013.517-5.067 1.667 1.667 0 00-1.017-.35h-4.166A1.666 1.666 0 0014 26.5v3.958a.208.208 0 00.208.209h3.125v-.417zm5.417-3.75h7.5A3.743 3.743 0 0134 30.25v3.333a.417.417 0 01-.417.417H19.417a.417.417 0 01-.417-.417V30.25a3.743 3.743 0 013.75-3.75z\" fill=\"#fff\"/></g><defs><clipPath id=\"clip0_4965_1185\"><path fill=\"#fff\" transform=\"translate(14 14)\" d=\"M0 0h20v20H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "48",
    "height": "48",
    "viewBox": "0 0 48 48",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};